<script>
import ClMaster from '@/models/ClMaster.js'
import ClInstance from '@/models/ClInstance.js'
import User from '@/models/User.js'
import { mapState } from 'vuex'
import Logger from '@/lib/Logger'

export default {
  name: 'Test',

  data: () => ({
    clMasters: [], // array che sarà valorizzato da una activeQuery
    server_user: {},
  }),
  computed: {
    ...mapState(['userLogged']),
  },
  created() {
    this.queries = [
      ClInstance.select({
        get: '{ id, title }',
        by: { clMasterId: 11 },
        onChange: data => {
          this.clMasters = data
        },
      }),

      User.find({
        get: '{ id, mailinglistAccepted }',
        by: { id: this.userLogged.id },
        onChange: data => {
          this.server_user = data
        },
      }),
    ]
    // console.log('[Test.vue] Created Queries', this.userLogged)
    Logger.debug('[Test.vue] Created Queries', this.userLogged)
  },

  beforeDestroy() {
    this.queries.forEach(q => q.destroy())
  },

  methods: {
    addNew() {
      ClMaster.addNew({ title: `${Date.now()}`, workspaceId: '1' })
    },

    isLogged() {
      return User.isLogged()
    },

    logout() {
      User.doLogout()
      this.$store.commit('userLoggedOut')
    },
  },
}
</script>

<template>
  <v-container>
    <h1>{{ $t('message.authenticated') }}: {{ isLogged() }}</h1>
    <div align="right">
      <button @click="logout()">Logout</button>
    </div>
    {{ userLogged }}
    <hr />
    {{ server_user.email }}
    <!-- un semplice codice di verifica dell'architettura -->
    <div style="height: 100px;" />
    <div style="background-color: #888; padding: 20px;">
      <hr />
      <h3>Quick test NEW</h3>
      <div v-for="clMaster in clMasters" :key="clMaster.id">
        {{ clMaster.title }}
      </div>
      <button style="border: solid 1px; padding: 0px 3px;" @click="addNew()">
        Add
      </button>
    </div>
  </v-container>
</template>
